<!--
 * @Date: 2023-12-29 10:03:15
 * @LastEditors: fuRan NgeKaworu@gmail.com
 * @LastEditTime: 2023-12-29 10:22:09
 * @FilePath: /newhome-common-h5/src/views/home/xiaomi.vue
-->
<template>
  <div class="containor">
    <van-nav-bar class="title" title="小米手机设置" left-text="返回" left-arrow @click-left="onClickLeft" />
    <h3>一、消息通知设置</h3>
    <p>
      小米手机需要开启“星智家”APP自动运行应用程序，主要是解决使用APP无法及时收到新消息通知。如果你能收到消息通知，请忽略。
    </p>
    <p>
      导致原因：
      因为小米手机系统在黑屏待机后自动清理后台运行的软件，这样影响了我们正常接受到新的消息，需要将APP这类软件设置为自动运行应用程序。
      如何设置：
    </p>
    <p>1、开启自启动： 设置-应用设置-授权管理-自启动管理-星智家打开</p>
    <img src="../../assets/images/xiaomiStepOne.png" />
    <img src="../../assets/images/xiaomiStepTwo.png" />
    <img src="../../assets/images/xiaomiStepThree.png" />
    <img src="../../assets/images/xiaomiStepFour.png" />
    <p>2、省电设置模式：设置-电池与性能-设置-应用智能省电-选中星智家-不采取任何措施</p>
    <img src="../../assets/images/xiaomiStepFive.png" />
    <img src="../../assets/images/xiaomiStepSix.png" />
    <img src="../../assets/images/xiaomiStepSeven.png" />
    <img src="../../assets/images/xiaomiStepEight.png" />
    <img src="../../assets/images/xiaomiStepNine.png" />
    <p>3、通知设置： 设置-通知管理-星智家-全部打开</p>
    <img src="../../assets/images/xiaomiStepTen.png" />
    <img src="../../assets/images/xiaomiStepEleven.png" />
    <img src="../../assets/images/xiaomiStepTwelve.png" />
    <p>
      4、多任务界面锁定“星智家”APP：
      点击手机左下角功能键-进入多任务页面-找到星智家APP-长按-点击左侧弹出锁的按钮
    </p>
    <img src="../../assets/images/xiaomiStepThirteen.png" />
    <h3>二、消息铃声设置</h3>
    <video width="100%" height="100%" style="width: 100%; height: 100%; object-fit: fill" controls>
      <source src="../../assets/video/XIAOMI.mp4" type="video/mp4" />
    </video>
    <a :href="require('../../assets/video/XIAOMI.mp4')">全屏观看</a>
    <p>Tip: 若用户不喜欢系统自定义铃声，可在声音里面更改自己喜欢的本地铃声。</p>

  </div>
</template>

<script>
export default {
  name: 'xiaomi',
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="less" scoped>
.containor {
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow-x: hidden;
  align-items: center;
  padding: 0 5px 15px 5px;

  h1 {
    margin-top: 20rem;
    font-size: 32px;
  }

  p {
    max-width: 900px;
    line-height: 2rem;
    font-size: 14px;
    margin: auto;
  }
}

.title {
  width: 100%;
}
</style>
